// extracted by mini-css-extract-plugin
export default {"cameraIcon":"Avatar_cameraIcon__tEMmB","placeholderImg":"Avatar_placeholderImg__jJC2R","placeholderImgWrapper":"Avatar_placeholderImgWrapper__9aMo+"};